<template>
  <div style="padding-top: 40px; padding-left: 0px;">
    <!-- <button @click="clickoutside">stop</button> -->
    <i style="position: absolute; left: 30px; top: 25px; font-size: 24px;">Enter password....</i>
    <div
      style=" width: 95%; margin-left: 2.5%; height: 80px; border: 1px solid gray; border-radius: 9px; overflow: hidden;"
    >
      <input type="text" class="setting_input" v-model="Pass" readonly="true" max="6">
    </div>
    <div id="countdown"></div>
    <button class="btn btn-primary bt-setting" @click="addKey(1)">1</button>
    <button class="btn btn-primary bt-setting" @click="addKey(2)">2</button>
    <button class="btn btn-primary bt-setting" @click="addKey(3)">3</button>
    <button class="btn btn-primary bt-setting" @click="addKey(4)">4</button>
    <button class="btn btn-primary bt-setting" @click="addKey(5)">5</button>
    <button class="btn btn-primary bt-setting" @click="addKey(6)">6</button>
    <button class="btn btn-primary bt-setting" @click="addKey(7)">7</button>
    <button class="btn btn-primary bt-setting" @click="addKey(8)">8</button>
    <button class="btn btn-primary bt-setting" @click="addKey(9)">9</button>
    <button class="btn btn-primary bt-setting" @click="addKey(0)">0</button>
    <button class="btn btn-danger bt-setting" @click="removeKey">
      <img src="../../assets/left-arrow.png">
    </button>
    <button class="btn btn-success bt-setting" @click="gotoSetting">
      <img src="../../assets/padlock-unlock.png">
    </button>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import $ from "jquery";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Swal from "sweetalert2";
import api from "../../service/services";
export default {
  data() {
    return {
      authen_qrcode: '',
      time: 0,
      step:'',
      Pass: "",
      timeleft:0,
      downloadTimer:'',
    };
  },
  computed: {
    ...mapState([
      "lang",
      "UUID",
      "accessToken",
      "Mode",
      "Type",
      "AmountPayment",
      "AuthenType",
      "isconnect_emitterpay",
      "StatusQrcode",
      "customerBalance"
    ]),
    ...mapMutations(["onMessageWs"])
  },
  methods: {
    addKey(int) {
      this.Soundclick();
      if (this.Pass.length < 6) {
        this.Pass += int.toString();
      }
    },
    removeKey() {
      this.Soundclick();
      var key = this.Pass;
      this.Pass = key.substring(key.length - 1, 0);
    },
    getAuthenPass() {
      const header = {
        headers: {
          // "x-access-token": "4fa68bf1a9e042e6bef54de6542c2efa"
          "x-access-token": this.$store.state.accessToken
        }
      };
      api.authenQrcode(
        header,
        result => {
          console.log("QR RESPONSE = " + JSON.stringify(result))
          console.log(" result.passcode", result)
          this.authen_qrcode = result.passcode;
          //this.authen_qrcode = '0987';
          this.timeleft = result.remain_sec;
          console.log("Password =",this.authen_qrcode);
          console.log("time",this.timeleft);
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      );
    },
    gotoSetting() {
      this.Soundclick();
      if(this.Pass === this.authen_qrcode) {
        $('#Modal').modal('hide');
        this.$router.push('/setting')
        console.log("Password ถูกต้อง");
        this.timeleft = 0
      }else{
        alert('Password ไม่ถูกต้อง')
        this.Pass = ''
      }
    },
    clickoutside(){
       clearInterval(this.$store.state.downloadTimer)
    }
  },
  mounted() {
    this.getAuthenPass();
    this.Pass = "";
    this.$store.state.downloadTimer = setInterval(()=>{
      document.getElementById("countdown").innerHTML = this.timeleft + " seconds remaining";
      this.timeleft -= 1;
      if(this.timeleft <= 0){
        this.getAuthenPass();
        document.getElementById("countdown").innerHTML = this.timeleft
      }
      if(this.Pass == this.authen_qrcode){
        clearInterval(this.$store.state.downloadTimer)
      }
    }, 1000);
  }
};
</script>

<style>
.bt-setting {
  width: 30%;
  height: 90px;
  margin: 1% 1% 1% 1%;
  font-size: 100px;
  font-weight: bold;
  line-height: 30px;
  text-align: center;
  overflow: hidden;
}

.bt-setting span {
  line-height: 30px;
  margin: 0;
  padding: 0;
}

.setting_input {
  width: 95%;
  margin-left: 2.5%;
  height: 80px;
  padding-top: 20px;
  margin-right: 10px;
  border: 0px;
  font-size: 198px;
  line-height: 300px;
  text-align: right;
  -webkit-text-security: disc;
  overflow: hidden;
  margin-bottom: 0px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/modal/keypad.vue